<template>
  <div v-loading="loading" class="nx-page meterenergy-analysis">
    <el-card shadow="never">
      <div slot="header" class="card-head">
        <span>用水量概览（抄表）</span>
        <div class="filters">
          <el-date-picker v-model="billingMonth" type="month" value-format="yyyyMM" clearable size="small" style="width: 150px" />
          <el-button type="primary" size="small" @click="load">查询</el-button>
        </div>
      </div>
      <div class="kpi-row">
        <div class="kpi-card">
          <div class="kpi-label">账单月用水合计（m³）</div>
          <div class="kpi-value">{{ fmtNum(data.totalM3) }}</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">环比</div>
          <div class="kpi-value sm">{{ data.monthOnMonthPercent != null ? fmtPct(data.monthOnMonthPercent) : '—' }}</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">抄表条数</div>
          <div class="kpi-value">{{ data.recordCount != null ? data.recordCount : '—' }}</div>
        </div>
      </div>
      <el-row :gutter="16">
        <el-col :md="14" :xs="24">
          <div class="chart-title">近 6 月各类目用水（堆叠 m³）</div>
          <div ref="chartStack" class="chart-box" />
        </el-col>
        <el-col :md="10" :xs="24">
          <div class="chart-title">当前月类目占比</div>
          <div ref="chartPie" class="chart-box" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { fetchWaterOverview } from './api'

const COLORS = ['#0284c7', '#7c3aed', '#059669', '#f59e0b', '#64748b']

export default {
  name: 'MeterEnergyWaterOverview',
  data() {
    return { loading: false, billingMonth: null, data: {}, charts: [] }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    this.charts.forEach((c) => c.dispose())
  },
  methods: {
    fmtNum(v) {
      if (v == null) return '—'
      return Number(v).toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    fmtPct(v) {
      const n = Number(v)
      return (n >= 0 ? '+' : '') + n.toFixed(2) + '%'
    },
    resize() {
      this.charts.forEach((c) => c.resize())
    },
    async load() {
      this.loading = true
      try {
        const res = await fetchWaterOverview({ billingMonth: this.billingMonth || undefined })
        this.data = (res.data && res.data.data) || {}
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    renderCharts() {
      this.charts.forEach((c) => c.dispose())
      this.charts = []
      const d = this.data
      const months = (d.monthlyTotals || []).map((x) => x.billingMonth)
      const series = d.stackByCategory || []
      const stack = echarts.init(this.$refs.chartStack)
      stack.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { bottom: 0, type: 'scroll' },
        grid: { left: 48, right: 16, top: 24, bottom: 56 },
        xAxis: { type: 'category', data: months },
        yAxis: { type: 'value', name: 'm³' },
        series: series.map((s, i) => ({
          name: s.category,
          type: 'bar',
          stack: 'w',
          data: (s.data || []).map((v) => Number(v) || 0),
          itemStyle: { color: COLORS[i % COLORS.length] }
        }))
      })
      this.charts.push(stack)

      const cats = d.categoryUsages || []
      const pie = echarts.init(this.$refs.chartPie)
      pie.setOption({
        tooltip: { trigger: 'item' },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            data: cats.map((c, i) => ({
              name: c.category,
              value: Number(c.usageAmount) || 0,
              itemStyle: { color: COLORS[i % COLORS.length] }
            })),
            label: { formatter: '{b}\n{d}%' }
          }
        ]
      })
      this.charts.push(pie)
    }
  }
}
</script>

<style scoped>
.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.filters {
  display: flex;
  gap: 8px;
  align-items: center;
}
.mb12 {
  margin-bottom: 12px;
}
.kpi-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .kpi-row {
    grid-template-columns: 1fr;
  }
}
.kpi-card {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 12px;
  padding: 14px 16px;
}
.kpi-label {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 6px;
}
.kpi-value {
  font-size: 22px;
  font-weight: 700;
  color: #0369a1;
}
.kpi-value.sm {
  font-size: 16px;
}
.chart-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.chart-box {
  height: 300px;
  width: 100%;
}
</style>
